import { useState } from "react";

const useSearchFilters = () => {
  const [searchString, setSearchString] = useState<string>('');

  const handleSearch = (value: string) => {
    setSearchString(value);
  }

  return {
    searchString,
    handleSearch
  }
}

export default useSearchFilters